"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationAlignments = exports.TitleSizes = void 0;
var TitleSizes;
exports.TitleSizes = TitleSizes;

(function (TitleSizes) {
  TitleSizes["Small"] = "SMALL";
  TitleSizes["Medium"] = "MEDIUM";
  TitleSizes["Large"] = "LARGE";
})(TitleSizes || (exports.TitleSizes = TitleSizes = {}));

var NavigationAlignments;
exports.NavigationAlignments = NavigationAlignments;

(function (NavigationAlignments) {
  NavigationAlignments["Leading"] = "ALIGNMENTS/LEADING";
  NavigationAlignments["Trailing"] = "ALIGNMENTS/TRAILING";
})(NavigationAlignments || (exports.NavigationAlignments = NavigationAlignments = {}));